import { concatStrings } from '@/services/helpers'
import { LoanContact, UserLoan } from '@matech/thebigpos-sdk'

export type BorrowerInfo = {
	name: string
	email: string
	phone?: string | null
}

export type BorrowerResult = {
	borrower?: BorrowerInfo
	coBorrower?: BorrowerInfo
}

export default function extractBorrowerAndCoBorrowerFromLoansAndContacts(
	userLoans?: UserLoan[],
	loanContacts?: LoanContact[]
): BorrowerResult {
	const borrowerMap = new Map<string, BorrowerInfo>()
	const coBorrowerMap = new Map<string, BorrowerInfo>()

	userLoans?.forEach((item) => {
		const { user, role } = item

		const fullName = concatStrings(
			user.firstName,
			user.lastName
		).getValue()

		if (!fullName) return

		const userEmail = user.email

		const borrowerInfo: BorrowerInfo = {
			name: fullName,
			email: userEmail,
			phone: user.phone,
		}

		if (role === 'Borrower') borrowerMap.set(userEmail, borrowerInfo)

		if (role === 'CoBorrower') {
			coBorrowerMap.set(userEmail, borrowerInfo)
		}
	})

	loanContacts?.forEach((item) => {
		if (!item.email) return

		const fullName =
			item.fullName ||
			concatStrings(item.firstName, item.lastName).getValue()

		if (!fullName) return

		const userEmail = item.email

		const coBorrowerInfo: BorrowerInfo = {
			name: fullName,
			email: userEmail,
			phone: item.phone,
		}

		if (item.role === 'Borrower' && !borrowerMap.has(item.email)) {
			borrowerMap.set(item.email, coBorrowerInfo)
		}

		if (
			item.role === 'CoBorrower' &&
			!coBorrowerMap.has(item.email)
		) {
			coBorrowerMap.set(item.email, coBorrowerInfo)
		}
	})

	const borrowers = Array.from(borrowerMap.values())
	const coBorrowers = Array.from(coBorrowerMap.values())

	return {
		borrower: borrowers[0],
		coBorrower: coBorrowers[0],
	}
}
